export interface purchaseOrderDetail {
    key: number;
    id: number;
    purchase_order?: number;
    product: number;
    product_code: string;
    product_name: string;
    product_unit?: number;
    product_unit_name?: string;
    quantity: number;
    current_stock?: number;
    /** The shop's order point ("จุดสั่งซื้อ"), or null where none is set. */
    point_purchase?: number | string | null;
    /** Pulled in by the auto-fill without a "จำนวนสั่งซื้อเริ่มต้น": the
     *  quantity is blank until someone types it. Never saved as such. */
    needs_quantity?: boolean;
    weight?: number;
    cost: number;
    total_cost: number;
    vat?: number;
    remark?: string;
    status: number;
}

export interface purchaseOrder {
    key: number;
    id: number;
    document_no: string;
    vendor: number;
    vendor_name?: string;
    vendor_tel?: string;
    vendor_address?: string;
    quantity: number;
    weight: number;
    cost: number;
    vat: number;
    vat_amount?: number;
    total_cost?: number;
    remark: string;
    status: number; // 1: Draft, 2: Sent to Vendor / Waiting, 3: Completed / Received, 0: Cancelled
    create_by?: number;
    create_by_name?: string;
    create_date: string;
    update_date?: string;
    detail: purchaseOrderDetail[];
    active_draft_gr_id?: number | null;
    active_draft_doc_no?: string | null;
}

export const initPurchaseOrderDetail: purchaseOrderDetail = {
    key: 0,
    id: 0,
    product: 0,
    product_code: "",
    product_name: "",
    quantity: 1,
    current_stock: 0,
    point_purchase: null,
    weight: 0,
    cost: 0,
    total_cost: 0,
    vat: -1,
    remark: "",
    status: 1
};

export const initPurchaseOrder: purchaseOrder = {
    key: 0,
    id: 0,
    document_no: "",
    vendor: 0,
    vendor_name: "",
    quantity: 0,
    weight: 0,
    cost: 0,
    vat: -1,
    vat_amount: 0,
    total_cost: 0,
    remark: "",
    status: 1,
    create_date: "",
    detail: []
};
